import { createAction } from '@reduxjs/toolkit';

import { NotificationActions } from "../constants/notifications/actions";
import { ActionSuffixes } from "../constants/common/actions";

export const createShowErrorAction = () => createAction(NotificationActions.NotificationError + ActionSuffixes._Set,
    (message: string) => ({ meta: { prefix: NotificationActions.NotificationError }, payload: message }));

export const createShowInfoAction = () => createAction(NotificationActions.NotificationInfo + ActionSuffixes._Set,
    (message: string) => ({ meta: { prefix: NotificationActions.NotificationInfo }, payload: message }));

export const createShowSuccessAction = () => createAction(NotificationActions.NotificationSuccess + ActionSuffixes._Set,
    (message: string) => ({ meta: { prefix: NotificationActions.NotificationSuccess }, payload: message}));

export const createShowWarningAction = () => createAction(NotificationActions.NotificationWarning + ActionSuffixes._Set,
    (message: string) => ({ meta: { prefix: NotificationActions.NotificationWarning }, payload: message }));
